module.exports = __webpack_public_path__ + "static/media/Flik3_Färgsymboler.c5c51bb4.pdf";